module.exports = __webpack_public_path__ + "1c_fran_black.fa7bffc809b6bed8d053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1c_fran_black.png
// module id = 270
// module chunks = 2